export enum AdminReportInterval {
  Day = 'day',
  Week = 'week',
  Never = 'never',
}
